<template>
  <div class="complain-notification" v-click-outside="close">
    <a href="#" class="notification-bell" @click.prevent="toggle">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6"/>
      </svg>
      <span v-if="complains.length > 0" class="notification-badge">{{ complains.length > 99 ? '99+' : complains.length }}</span>
    </a>

    <div v-show="isOpen" class="notification-menu">
      <div class="notification-header">Complain Replies</div>
      <div v-if="complains.length === 0" class="text-center text-muted small py-3">No new replies</div>
      <div v-for="complain in complains" :key="complain.id" class="notification-item" @click="openComplain(complain)">
        <div class="notification-item-title">{{ complain.title }}</div>
        <div class="notification-item-sub">{{ complain.code }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'ComplainNotification',
  directives: {
    'click-outside': {
      bind (el, binding) {
        el.__clickOutsideHandler = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event)
          }
        }
        document.addEventListener('click', el.__clickOutsideHandler)
      },
      unbind (el) {
        document.removeEventListener('click', el.__clickOutsideHandler)
      },
    },
  },
  data () {
    return {
      isOpen: false,
      complains: [],
      knownIds: null,
      pollTimer: null,
    }
  },
  created () {
    this.fetchNotifications()
    this.pollTimer = setInterval(this.fetchNotifications, 30000)
  },
  beforeDestroy () {
    clearInterval(this.pollTimer)
  },
  methods: {
    toggle () {
      this.isOpen = !this.isOpen
    },
    close () {
      this.isOpen = false
    },
    async fetchNotifications () {
      const response = await config.getData('/complain/notifications')
      const complains = response.success ? response.data.complains : []

      if (this.knownIds !== null) {
        complains
          .filter(c => !this.knownIds.has(c.id))
          .forEach(c => {
            this.$toast.info({ title: 'New reply on your complain', message: c.title })
          })
      }
      this.knownIds = new Set(complains.map(c => c.id))

      this.complains = complains
    },
    openComplain (complain) {
      this.complains = this.complains.filter(c => c.id !== complain.id)
      this.knownIds && this.knownIds.delete(complain.id)
      config.postData(`/complain/read/${complain.id}`)
      this.close()
      this.$router.push({ name: 'complain' })
    },
  },
}
</script>

<style scoped>
.complain-notification {
  position: relative;
  margin-right: 14px;
}
.notification-bell {
  position: relative;
  display: inline-block;
  color: #fff;
}
.notification-badge {
  position: absolute;
  top: -6px;
  right: -10px;
  background: #dc3545;
  color: #fff;
  border-radius: 10px;
  font-size: 10px;
  padding: 1px 5px;
  line-height: 1.4;
}
.notification-menu {
  position: absolute;
  top: 34px;
  right: 0;
  width: 300px;
  max-height: 360px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  z-index: 1100;
}
.notification-header {
  padding: 10px 14px;
  font-weight: 600;
  border-bottom: 1px solid #eee;
}
.notification-item {
  padding: 8px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
}
.notification-item:hover {
  background: #f8f9fa;
}
.notification-item-title {
  font-size: 13px;
  font-weight: 600;
}
.notification-item-sub {
  font-size: 12px;
  color: #6c757d;
}
</style>
